export function initSitemap() {
// Sitemap toggle functionality - support multiple instances
const sitemapToggles = document.querySelectorAll('.c_sitemap-toggle');
    
sitemapToggles.forEach(sitemapToggle => {
    // Find the associated content - either by data-target or next sibling with class
    const targetId = sitemapToggle.getAttribute('data-target');
    const sitemapContent = targetId 
        ? document.getElementById(targetId)
        : sitemapToggle.nextElementSibling?.classList.contains('c_sitemap-content') 
            ? sitemapToggle.nextElementSibling 
            : document.getElementById('sitemap-section');
        
    const sitemapIcon = sitemapToggle.querySelector('.c_sitemap-toggle-icon');
        
    if (sitemapContent) {
        sitemapToggle.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
                
            const isOpen = sitemapContent.classList.contains('is-open');
            const isDesktop = window.innerWidth >= 768;
                
            // Toggle aria-expanded
            sitemapToggle.setAttribute('aria-expanded', !isOpen);
                
            // Rotate the icon
            if (sitemapIcon) {
                if (!isOpen) {
                    sitemapIcon.style.transform = 'rotate(180deg)';
                } else {
                    sitemapIcon.style.transform = 'rotate(0deg)';
                }
            }
                
            // Desktop: Slide toggle with animation
            // Mobile: Simple toggle without animation
            if (isDesktop) {
                if (!isOpen) {
                    // Opening: set max-height first, then add is-open class after animation
                    sitemapContent.style.maxHeight = sitemapContent.scrollHeight + 'px';
                    sitemapContent.addEventListener('transitionend', function handler() {
                        if (sitemapContent.classList.contains('is-open')) {
                            sitemapContent.style.maxHeight = 'none';
                        }
                        sitemapContent.removeEventListener('transitionend', handler);
                    });
                        
                    // Add is-open class after animation completes to prevent white flash
                    setTimeout(() => {
                        sitemapContent.classList.add('is-open');
                    }, 500);
                        
                    // Scroll to absolute bottom of page after animation starts
                    setTimeout(() => {
                        window.scrollTo({ 
                            top: document.documentElement.scrollHeight, 
                            behavior: 'smooth' 
                        });
                    }, 500);
                } else {
                    // Closing: remove is-open class immediately, set pixel value then collapse
                    sitemapContent.classList.remove('is-open');
                    sitemapContent.style.maxHeight = sitemapContent.scrollHeight + 'px';
                    requestAnimationFrame(() => {
                        sitemapContent.style.maxHeight = '0';
                    });
                }
            } else {
                    
                if (isOpen) {
                    sitemapContent.classList.remove('is-open');
                }
                else {
                    sitemapContent.classList.add('is-open');
                    setTimeout(() => {
                        window.scrollTo({
                            top: document.documentElement.scrollHeight,
                            behavior: 'smooth'
                        });
                    }, 500);
                }
            }
        });
    }
});
    
    // Sitemap accordion functionality (for individual sitemap items on mobile)
    const sitemapAccordions = document.querySelectorAll('.c_sitemap-accordion');
    
    sitemapAccordions.forEach(accordion => {
        const trigger = accordion.querySelector('.c_sitemap-accordion-trigger');
        const content = accordion.querySelector('.c_sitemap-accordion-content');
        const icon = trigger?.querySelector('.c_sitemap-accordion-icon');

        if (trigger && content) {
            const handleToggle = function () {
                // Only work on mobile (below 640px for small screens)
                if (window.innerWidth >= 640) return;
                
                const isOpen = accordion.classList.contains('is-open');
                
                // Toggle the open state
                accordion.classList.toggle('is-open');
                
                // Toggle aria-expanded
                trigger.setAttribute('aria-expanded', !isOpen);
                
                // Rotate icon
                if (icon) {
                    if (!isOpen) {
                        icon.style.transform = 'rotate(-180deg)';
                    } else {
                        icon.style.transform = 'rotate(0deg)';
                    }
                }
                
                // Slide toggle the content
                if (!isOpen) {
                    content.style.maxHeight = content.scrollHeight + 'px';
                } else {
                    content.style.maxHeight = '0';
                }
            };

            // Click event
            trigger.addEventListener('click', handleToggle);
            
            // Keyboard events for accessibility
            trigger.addEventListener('keydown', function (e) {
                if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    handleToggle();
                }
            });
        }
    });
    
    // Handle resize to reset sitemap accordion state on tablet/desktop
    let resizeTimer;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function() {
            if (window.innerWidth >= 640) {
                sitemapAccordions.forEach(accordion => {
                    const trigger = accordion.querySelector('.c_sitemap-accordion-trigger');
                    const content = accordion.querySelector('.c_sitemap-accordion-content');
                    const icon = trigger?.querySelector('.c_sitemap-accordion-icon');
                    
                    if (content) {
                        content.style.maxHeight = '';
                    }
                    if (icon) {
                        icon.style.transform = '';
                    }
                    if (trigger) {
                        trigger.setAttribute('aria-expanded', 'false');
                    }
                    accordion.classList.remove('is-open');
                });
            }
        }, 250);
    });

    // Nested sitemap accordion toggles
    const nestedToggles = document.querySelectorAll('.c_sitemap-nested-toggle');

    nestedToggles.forEach(toggle => {
        const parentItem = toggle.closest('.c_sitemap-nested-accordion');
        const content = parentItem?.querySelector(':scope > .c_sitemap-nested-content');
        const icon = toggle.querySelector('.c_sitemap-nested-toggle-icon');

        if (content) {
            toggle.addEventListener('click', function (e) {
                e.preventDefault();
                const isOpen = parentItem.classList.contains('is-open');

                parentItem.classList.toggle('is-open');
                toggle.setAttribute('aria-expanded', !isOpen);

                if (icon) {
                    icon.style.transform = !isOpen ? 'rotate(180deg)' : 'rotate(0deg)';
                }

                if (!isOpen) {
                    // Animate open: set pixel value, then swap to none after transition
                    content.style.maxHeight = content.scrollHeight + 'px';
                    content.addEventListener('transitionend', function handler() {
                        if (parentItem.classList.contains('is-open')) {
                            content.style.maxHeight = 'none';
                        }
                        content.removeEventListener('transitionend', handler);
                    });
                } else {
                    // Animate closed: set current height first so transition works from a value
                    content.style.maxHeight = content.scrollHeight + 'px';
                    requestAnimationFrame(() => {
                        content.style.maxHeight = '0';
                    });
                }

                // Update all ancestor nested containers to allow growing
                let ancestor = parentItem.parentElement?.closest('.c_sitemap-nested-accordion');
                while (ancestor) {
                    const ancestorContent = ancestor.querySelector(':scope > .c_sitemap-nested-content');
                    if (ancestorContent && ancestor.classList.contains('is-open')) {
                        ancestorContent.style.maxHeight = 'none';
                    }
                    ancestor = ancestor.parentElement?.closest('.c_sitemap-nested-accordion');
                }

                // Also update the top-level sitemap accordion content on mobile
                const topAccordionContent = parentItem.closest('.c_sitemap-accordion-content');
                if (topAccordionContent && topAccordionContent.style.maxHeight) {
                    topAccordionContent.style.maxHeight = 'none';
                }

                // Also update the sitemap section container (desktop)
                const sitemapSection = parentItem.closest('.c_sitemap-content');
                if (sitemapSection && sitemapSection.style.maxHeight) {
                    sitemapSection.style.maxHeight = 'none';
                }
            });
        }
    });
}
